// const lr = () => import(/* webpackChunkName: "core-lr" */"../components/layouts/LR/layout-lr")
// const main = () => import(/* webpackChunkName: "core-lr" */"../components/layouts/LR/layout-main")


import lr from '../components/layouts/LR/layout-lr'
import main from '../components/layouts/LR/layout-main'

function setLayout(app, routes) {
    routes.forEach((route, index) => {
        if (route.children && route.children.length > 0) {
            if (!route.component) route.component = lr
            return true
        }
        route = {
            name: route.name + "-parent",
            text: route.text,
            path: '/main',
            component: main,
            redirect: { name: route.name },
            icon: route.icon,
            children: [route]
        }
        routes[index] = route;
    })
}

export default {
    name: "lr",
    maxWidth: 2560, 
    minWidth: 1024,
    login: null,
    text: "左右布局",
    desc:"适用于业务比较复杂，功能模块、菜单项目较多的场景，界面操作效率高",
    layout: setLayout
}